import { render, staticRenderFns } from "./PersonalInformationView2.vue?vue&type=template&id=7851d45e&scoped=true"
import script from "./PersonalInformationView2.vue?vue&type=script&lang=js"
export * from "./PersonalInformationView2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7851d45e",
  null
  
)

export default component.exports